import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "image-wrap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "fullscreen-overlay bg-black flex flex-center" }
const _hoisted_4 = { class: "zoom-controls absolute-bottom-right q-ma-lg" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_touch_pan = _resolveDirective("touch-pan")!
  const _directive_touch_pinch = _resolveDirective("touch-pinch")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message-img-wrapper", { '--is-widget': _ctx.isWidget }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.src,
        alt: "image",
        onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadedImage && _ctx.loadedImage(...args))),
        class: "cursor-pointer",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openFullscreen && _ctx.openFullscreen(...args)))
      }, null, 40, _hoisted_2)
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.isFullscreen,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isFullscreen) = $event)),
      maximized: "",
      "transition-show": "fade",
      "transition-hide": "fade",
      onHide: _ctx.resetZoom
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_btn, {
            icon: "close",
            color: "white",
            class: "close-btn absolute-top-right q-ma-md",
            onClick: _ctx.closeFullscreen,
            round: "",
            dense: "",
            flat: "",
            size: "lg"
          }, null, 8, ["onClick"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_q_btn, {
              icon: "add",
              color: "white",
              onClick: _ctx.zoomIn,
              round: "",
              dense: "",
              flat: ""
            }, null, 8, ["onClick"]),
            _createVNode(_component_q_btn, {
              icon: "remove",
              color: "white",
              onClick: _ctx.zoomOut,
              round: "",
              dense: "",
              flat: ""
            }, null, 8, ["onClick"]),
            _createVNode(_component_q_btn, {
              icon: "refresh",
              color: "white",
              onClick: _ctx.resetZoom,
              round: "",
              dense: "",
              flat: ""
            }, null, 8, ["onClick"])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "zoom-container",
            onWheel: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleWheel && _ctx.handleWheel(...args)))
          }, [
            _createElementVNode("img", {
              ref: "fullscreenImage",
              src: _ctx.src,
              draggable: "false",
              onDragstart: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
              onDblclick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleZoom && _ctx.toggleZoom(...args))),
              alt: "image",
              class: "fullscreen-image",
              style: _normalizeStyle({
							transform: `translate(${_ctx.panX}px, ${_ctx.panY}px) scale(${_ctx.zoomLevel})`,
							transition: _ctx.isZooming ? 'none' : 'transform 0.2s ease',
							cursor: _ctx.isDragging ? 'grabbing' : _ctx.zoomLevel > 1 ? 'grab' : 'zoom-in'
						})
            }, null, 44, _hoisted_5)
          ], 32)), [
            [
              _directive_touch_pan,
              _ctx.handlePan,
              void 0,
              { mouse: true }
            ],
            [_directive_touch_pan, _ctx.handlePan],
            [_directive_touch_pinch, _ctx.handlePinch]
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onHide"])
  ], 2))
}